function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.global-this.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import { useState, useEffect } from "react";
import mediaQuery from "css-mediaquery";
import usePochtaTheme from "./usePochtaTheme";
import { useSsr } from "../ssr/SsrProvider";

var ssrMatchMedia = function ssrMatchMedia(query, ssrScreenWidth) {
  return mediaQuery.match(query.replace("@media ", ""), {
    // У либы не правильные типы, данный пример валиден
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    type: "screen",
    width: "".concat(ssrScreenWidth, "px")
  });
};

var useMatchMedia = function useMatchMedia(breakpoint) {
  var _media;

  var windowObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis;

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr,
      _useSsr$ssrScreenWidt = _useSsr.ssrScreenWidth,
      ssrScreenWidth = _useSsr$ssrScreenWidt === void 0 ? 0 : _useSsr$ssrScreenWidt;

  var theme = usePochtaTheme();
  var breakpoints = theme.breakpoints,
      breakpointsHelpers = theme.breakpointsHelpers,
      _theme$breakpointsHel = theme.breakpointsHelpers,
      up = _theme$breakpointsHel.up,
      isComplexBreakpoint = _theme$breakpointsHel.isComplexBreakpoint;
  var media;

  if (breakpoints) {
    if (typeof breakpoint === "string") {
      media = isComplexBreakpoint(breakpoint) ? breakpoints[breakpoint] : up(breakpoint);
    }

    if (typeof breakpoint === "function") {
      media = breakpoint(breakpointsHelpers);
    }
  }

  var mql = null;

  if (!isSsr && typeof media === "string" && (_media = media) !== null && _media !== void 0 && _media.startsWith("@media")) {
    var _windowObject$matchMe;

    mql = windowObject === null || windowObject === void 0 ? void 0 : (_windowObject$matchMe = windowObject.matchMedia) === null || _windowObject$matchMe === void 0 ? void 0 : _windowObject$matchMe.call(windowObject, media.replace("@media ", ""));
  }

  var getValue = function getValue() {
    var _mql;

    return ((_mql = mql) === null || _mql === void 0 ? void 0 : _mql.matches) || false;
  };

  var getSsrValue = function getSsrValue(query) {
    try {
      return ssrMatchMedia(String(query), ssrScreenWidth);
    } catch (_unused) {
      return false;
    }
  };

  var _useState = useState(isSsr ? getSsrValue(media) : getValue()),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    var _mql2;

    if (isSsr) return;

    if (getValue() !== value) {
      setValue(getValue());
    }

    var handler = function handler() {
      return setValue(getValue);
    };

    (_mql2 = mql) === null || _mql2 === void 0 ? void 0 : _mql2.addListener(handler);
    return function () {
      var _mql3;

      (_mql3 = mql) === null || _mql3 === void 0 ? void 0 : _mql3.removeListener(handler);
    };
  }, [isSsr]);
  return value;
};

export default useMatchMedia;